import React from 'react';
import { PageLayout, PageLayoutContent } from '../../../components/layouts';
import { MyEvents } from '../../../features/acg/acg-my-events';

export const MyEventsPage: React.FC = () => {
  return (
    <PageLayout>
      <PageLayoutContent>
        <MyEvents />
      </PageLayoutContent>
    </PageLayout>
  );
};
